<div>
  <app-page-header pageTitle="{{ 'Dashboard.ProcedureCategories.Title' | translate }}">
    <div>
      <div class="d-inline-block">
        <mat-form-field>
          <input matInput (keyup)="filterCategories($event.target.value)"
                 placeholder="{{ 'Common.Filter' | translate }}">
        </mat-form-field>
      </div>

      <button class="ml-5"
              mat-raised-button color="primary"
              (click)="addNewCategoryAsync()">
        <fa-icon icon="plus" class="mr-1"></fa-icon>

        {{ 'Dashboard.ProcedureCategories.AddNewCategory' | translate }}
      </button>
    </div>
  </app-page-header>

  <div class="w-100">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z4 w-100">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Common.Name' | translate }}</th>
        <td mat-cell *matCellDef="let procedureCategory">
          <div *ngIf="!procedureCategory.isEditing">{{ procedureCategory.value.name }}</div>

          <div *ngIf="procedureCategory.isEditing">
            <mat-form-field>
              <input matInput placeholder="{{ 'Common.Name' | translate }}" [(ngModel)]="procedureCategory.value.name" required>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'Common.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let procedureCategory">
          <button mat-raised-button color="primary" class="mr-2"
                  *ngIf="!procedureCategory.isEditing"
                  [attr.title]="'Common.Edit' | translate"
                  (click)="startEditingCategoryAsync(procedureCategory)">
            <fa-icon icon="pencil-alt"></fa-icon>
          </button>

          <button mat-raised-button class="mr-2"
                  *ngIf="procedureCategory.isEditing"
                  (click)="cancelEditingCategoryAsync(procedureCategory)">
            {{ 'Common.Cancel' | translate }}
          </button>

          <app-button [loading]="updateCategoryInProgress" color="primary" class="mr-2"
                      *ngIf="procedureCategory.isEditing"
                      (click)="editCategoryAsync(procedureCategory)">
            {{ 'Common.Save' | translate }}
          </app-button>

          <button mat-raised-button color="warn"
                  [attr.title]="'Common.Remove' | translate"
                  (click)="removeCategoryAsync(procedureCategory)">
            <fa-icon icon="trash"></fa-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="text-center mt-3" *ngIf="isLoading">
      <app-loading-indicator></app-loading-indicator>
    </div>
  </div>
</div>